import * as React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { getMobileBrowserOS } from '@/redux/modules/browser';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import styles from './Mobile.module.scss';
import { useSelector } from 'react-redux';
import useWindowSize from '@/hooks/useWindowSize';

type Props = {
    alternative?: boolean;
    imageLess?: boolean;
    width?: number;
};

const Mobile = (props: Props) => {
    const { alternative, imageLess, width = 0 } = props;
    const mobileBrowserOS = useSelector(getMobileBrowserOS);
    const { width: windowWidth } = useWindowSize();
    const isIOS = mobileBrowserOS === 'ios';
    const isMobile = windowWidth < 767;

    const displayIOS = (isIOS && isMobile) || !isMobile;
    const displayAndroid = (!isIOS && isMobile) || !isMobile;

    if (isMobile && !alternative) {
        return null;
    }

    const mobileFooterClass = classNames(styles.mobile, Boolean(isMobile) && styles.displayMobile);
    const insideClasses = classNames(Boolean(alternative) && styles.alternative, styles.inside);

    const imageStyle = Boolean(width) ? { padding: 18, width: width } : { height: 40 };

    const badges = (
        <>
            {displayIOS && (
                <a
                    className={styles.badge}
                    href="https://itunes.apple.com/us/app/live-auctions/id321243082"
                    target="blank"
                    title="Available on the App Store"
                >
                    <ImageWithFallback
                        alt="mobile"
                        className={styles.iosBadge}
                        src="https://p1.liveauctioneers.com/dist/images/app_store.svg?auto=webp&format=pjpg&quality=60"
                        style={imageStyle}
                    />
                </a>
            )}
            {displayAndroid && (
                <a
                    className={styles.badge}
                    href="https://play.google.com/store/apps/details?id=com.liveauctioneers.and"
                    target="blank"
                    title="Android App on Google Play"
                >
                    <ImageWithFallback
                        alt="mobile"
                        className={styles.googleBadge}
                        src="https://p1.liveauctioneers.com/dist/images/Google_Play_Store_badge_EN.svg?auto=webp&format=pjpg&quality=60"
                        style={imageStyle}
                    />
                </a>
            )}
        </>
    );

    return imageLess ? (
        badges
    ) : (
        <div className={mobileFooterClass} id="getMobileBanner">
            <div className={insideClasses}>
                {displayIOS && (
                    <ImageWithFallback
                        alt="iphone"
                        className={classNames(styles.phoneImage, styles.iosPhoneImage)}
                        src="https://p1.liveauctioneers.com/dist/images/iPhoneXs_Download_Home.png"
                    />
                )}
                {displayAndroid && (
                    <ImageWithFallback
                        alt="androidPhone"
                        className={classNames(styles.phoneImage, styles.androidPhoneImage)}
                        src="https://p1.liveauctioneers.com/dist/images/Pixel3_Download_Home.png"
                    />
                )}
                <div className={styles.alternativeGrouping}>
                    {alternative ? (
                        <div>
                            <div className={styles.title}>
                                <FormattedMessage id="treasure_hunt" />
                            </div>
                            <div className={styles.body}>
                                <FormattedMessage id="bid_on_items_added_daily" />
                            </div>
                        </div>
                    ) : (
                        <div className={styles.footerText}>
                            <FormattedMessage id="get_notifications_from_favorite_auctioneers" />
                        </div>
                    )}
                    <div className={styles.groupedBadges}>{badges}</div>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(Mobile);
